import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { AuthConfigModule } from './core/auth/auth-config.module';
import {EventTypes, PublicEventsService} from 'angular-auth-oidc-client';
import {filter} from 'rxjs';
import {
    AddRemoveAssignmentsDialogComponent
} from './modals/add-remove-assignments-dialog/add-remove-assignments-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {FormsModule} from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import {UpdateRecordDialogComponent} from './modals/update-record-dialog/update-record-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FlexLayoutModule} from '@angular/flex-layout';
import {HelpDialogComponent, TermsDialogComponent} from './main/auth/sign-up/sign-up.component';
import {FuseLoadingModule} from '../@fuse/services/loading';
import {DownloadScriptsDialogComponent} from './main/studio-scripts/download-scripts-dialog/download-scripts-dialog.component';
import {FileManagerService} from './main/file-manager/file-manager.service';
import {ConfirmDialogComponent} from './modals/confirm-dialog/confirm-dialog.component';
import {MatInputModule} from '@angular/material/input';
import {SharedModule} from './shared/shared.module';
import {AudioRecordingService} from './services/audio-recording.service';
import {AWSPollyVoiceData} from './services/AWS_PollyVoiceData.Service';
import {CreatePromptDialogComponent} from './modals/create-prompt-dialog/create-prompt-dialog.component';
import {PollyPromptSaveDialogComponent} from './modals/polly-prompt-save-dialog/polly-prompt-save-dialog.component';
import {
    PollyPromptCreateDialogComponent
} from './modals/polly-prompt-create-dialog/polly-prompt-create-dialog.component';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {UploadScriptsDialogComponent} from './modals/upload-scripts-dialog/upload-scripts-dialog.component';
import {UploadFileDialogComponent} from './modals/upload-file-dialog/upload-file-dialog.component';
import {SaveFileDialogComponent} from './modals/save-file-dialog/save-file-dialog.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {UnauthorizedComponent} from './main/auth/unauthorized/unauthorized.component';
import {ScriptReferencesDialogComponent} from "./modals/script-references-dialog/script-references-dialog.component";
import {TrialDialogComponent} from "./main/auth/sign-in/sign-in.component";
import {SaveSkillsDialogComponent} from "./modals/save-skills-dialog/save-skills-dialog.component";
import {ProfileMatrixComponent} from "./main/profile-matrix/profile-matrix.component";
import {MatTableModule} from "@angular/material/table";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {SelectSkillDialogComponent} from "./modals/select-skill-dialog/select-skill-dialog.component";
import {MatListModule} from "@angular/material/list";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {
    ReorderDispositionsDialogComponent
} from "./modals/reorder-dispositions-dialog/reorder-dispositions-dialog.component";
import {CdkDrag, CdkDropList} from "@angular/cdk/drag-drop";
import { DigitalTagsComponent } from './main/digital-tags/digital-tags.component';
import {SaveDigitalTagsDialogComponent} from "./modals/save-digital-tags-dialog/save-digital-tags-dialog.component";
import {
    SubmitTranscriptionFilesDialogComponent
} from "./modals/submit-transcription-files-dialog/submit-transcription-files-dialog.component";
const routerConfig: ExtraOptions = {
    preloadingStrategy       : PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};

@NgModule({
    declarations: [
        AppComponent,
        AddRemoveAssignmentsDialogComponent,
        UpdateRecordDialogComponent,
        TermsDialogComponent,
        HelpDialogComponent,
        TrialDialogComponent,
        DownloadScriptsDialogComponent,
        ConfirmDialogComponent,
        UploadScriptsDialogComponent,
        UploadFileDialogComponent,
        SaveFileDialogComponent,
        PollyPromptSaveDialogComponent,
        SaveSkillsDialogComponent,
        SaveDigitalTagsDialogComponent,
        SubmitTranscriptionFilesDialogComponent,
        PollyPromptCreateDialogComponent,
        CreatePromptDialogComponent,
        UnauthorizedComponent,
        ScriptReferencesDialogComponent,
        ProfileMatrixComponent,
        DigitalTagsComponent,
        SelectSkillDialogComponent,
        ReorderDispositionsDialogComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,
        MatDialogModule,

        // 3rd party modules that require global configuration via forRoot
        AuthConfigModule,
        MatProgressBarModule,
        FormsModule,
        MatSliderModule,
        FlexLayoutModule,
        FuseLoadingModule,
        MatInputModule,
        SharedModule,
        MatIconModule,
        MatCheckboxModule,
        MatSelectModule,
        MatTabsModule,
        MatButtonModule,
        MatMenuModule,
        MatTooltipModule,
        MatTableModule,
        MatSlideToggleModule,
        MatListModule,
        ScrollingModule,
        CdkDropList,
        CdkDrag
    ],
    bootstrap   : [
        AppComponent
    ],
    providers: [
        MatSnackBar,
        FileManagerService,
        AudioRecordingService,
        AWSPollyVoiceData,
    ]
})
export class AppModule
{
    constructor(private readonly eventService: PublicEventsService) {
        this.eventService
            .registerForEvents()
            .pipe(filter(notification => notification.type === EventTypes.ConfigLoaded))
            .subscribe((config) => {
                //console.log('ConfigLoaded', config);
            });
    }
}
